export const UNPAID = 'UNPAID';



// WEBPACK FOOTER //
// ./src/const/paymentStatus.js